import { render, staticRenderFns } from "./MaterialIndex.vue?vue&type=template&id=3104d55d"
import script from "./MaterialIndex.vue?vue&type=script&lang=js"
export * from "./MaterialIndex.vue?vue&type=script&lang=js"
import style0 from "./MaterialIndex.vue?vue&type=style&index=0&id=3104d55d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports